import ACVideoPlayer from 'academy-common-lib/components/video/ACVideoPlayer';
import usageTracker from '../utils/usageTracker';
import { useEffect, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoPlayer = ({
  creatorHubId,
  videoId,
  creatorRegion
}) => {
  useEffect(() => {
    usageTracker.track('videoUsage', {
      type: 'rendered',
      videoId
    });
  }, [videoId]);
  const handleLoaded = useCallback(() => {
    usageTracker.track('videoUsage', {
      type: 'loaded',
      videoId
    });
  }, [videoId]);
  const handlePlay = useCallback(() => {
    usageTracker.track('videoUsage', {
      type: 'started',
      videoId
    });
  }, [videoId]);
  const handleMinutesWatched = useCallback(viewDuration => {
    usageTracker.track('videoUsage', {
      type: 'minutes-watched',
      videoId,
      viewDuration
    });
  }, [videoId]);
  const handleActivation = useCallback(() => {
    usageTracker.track('videoUsage', {
      type: 'engaged',
      videoId
    });
  }, [videoId]);
  const handleFinish = useCallback(() => {
    usageTracker.track('videoUsage', {
      type: 'finished',
      videoId
    });
  }, [videoId]);
  return /*#__PURE__*/_jsx(ACVideoPlayer, {
    creatorHubId: creatorHubId,
    creatorRegion: creatorRegion,
    onActivation: handleActivation,
    onFinish: handleFinish,
    onLoaded: handleLoaded,
    onPlay: handlePlay,
    onTimeProgress: handleMinutesWatched,
    videoId: videoId
  });
};
export default VideoPlayer;